import { render, staticRenderFns } from "./PalletScanner.vue?vue&type=template&id=24b7cda2&scoped=true&"
import script from "./PalletScanner.vue?vue&type=script&lang=js&"
export * from "./PalletScanner.vue?vue&type=script&lang=js&"
import style0 from "./PalletScanner.vue?vue&type=style&index=0&id=24b7cda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7cda2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VTextField})
